import React from 'react'
import './Row.css'

const Row = ({children, ...rest}) => {
    // available styles: no-grow-first, gap-[number], _no-grow-first, _no-grow-last, _no-grow, _space-between
    let classes = Object.keys(rest).filter(className => rest[className]).join(" ")
    return (
        <div className={`_row ${classes}`}>{children}</div>
    )
}

export default Row



// WEBPACK FOOTER //
// ./src/common/grid/Row.js